// PLAN.md §3.1 — handle validation, reserved-handle blocklist.

import { isProfane } from './profanity.js'

export const HANDLE_MIN_LEN = 3
export const HANDLE_MAX_LEN = 15
export const HANDLE_PATTERN = /^[A-Za-z0-9_-]+$/

export const RESERVED_HANDLES: ReadonlySet<string> = new Set([
  'admin', 'administrator',
  'mod', 'moderator',
  'system', 'root', 'operator',
  'anthropic',
  'lighter',
  'tradinggrounds', 'trading-grounds', 'grounds', 'tg',
  'support', 'help',
  'null', 'undefined',
  'team', 'staff',
  'bot', 'official',
])

export type HandleValidationError =
  | 'too_short'
  | 'too_long'
  | 'invalid_chars'
  | 'reserved'
  | 'profane'

export type HandleValidationResult =
  | { ok: true; canonical: string; display: string }
  | { ok: false; reason: HandleValidationError }

export function validateHandle(input: string): HandleValidationResult {
  const display = input
  if (display.length < HANDLE_MIN_LEN) return { ok: false, reason: 'too_short' }
  if (display.length > HANDLE_MAX_LEN) return { ok: false, reason: 'too_long' }
  if (!HANDLE_PATTERN.test(display)) return { ok: false, reason: 'invalid_chars' }
  const canonical = display.toLowerCase()
  if (RESERVED_HANDLES.has(canonical)) return { ok: false, reason: 'reserved' }
  if (isProfane(canonical)) return { ok: false, reason: 'profane' }
  return { ok: true, canonical, display }
}
